import { Pipe, PipeTransform } from '@angular/core';
import { ReadableEntityTypeService } from '@portal/entity-services/organisations/src/lib/services/readable-entity-type.service';

@Pipe({
  name: 'readableEntityType',
  standalone: false,
})
export class ReadableEntityTypePipe implements PipeTransform {
  constructor(private readableEntityTypeService: ReadableEntityTypeService) {}

  transform(entityTypeKey: string): string {
    const entityTypeValue = this.readableEntityTypeService.getEntityTypeValue(entityTypeKey);
    return entityTypeValue;
  }
}
